import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eCauTrucDeThiActionIds,
  ICauTrucDeThiActionTypes,
} from "../../action-types/de-thi/ICauTrucDeThiActions";
import { cauTrucDeThiApi } from "../../../api/de-thi/cauTrucDeThiApi";
import { ISMT_CauTrucDe_Insert_Request } from "../../../model/request/de-thi/ISMT_CauTrucDe_Insert_Request";

export function* cauTrucDeThiSaga(): any {
  yield takeLatest(eCauTrucDeThiActionIds.LOAD_START, loadWorker);
  yield takeLatest(
    eCauTrucDeThiActionIds.LOAD_START_CHON_CAU_HOI,
    loadChonCauHoiWorker
  );
  yield takeLatest(eCauTrucDeThiActionIds.DELETE_START, deleteWorker);
  yield takeLatest(eCauTrucDeThiActionIds.SAVE_START, saveWorker);
  yield takeLatest(
    eCauTrucDeThiActionIds.LOAD_SECTION_DATA_START,
    loadSectionWorker
  );
    yield takeLatest(
      eCauTrucDeThiActionIds.DELETE_MULTIPLE_START,
      deleteMultipleWorker
    );
}

function* loadWorker(action: ICauTrucDeThiActionTypes): any {
  const res: IBaseRespone = yield call(cauTrucDeThiApi.Select);
  if (res.is_success) {
    yield put(rootActions.deThi.cauTrucDeThi.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.deThi.cauTrucDeThi.LOAD_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* loadChonCauHoiWorker(action: ICauTrucDeThiActionTypes): any {
  const res: IBaseRespone = yield call(cauTrucDeThiApi.SelectAllVm);
  if (res.is_success) {
    yield put(
      rootActions.deThi.cauTrucDeThi.LOAD_SUCCESS_CHON_CAU_HOI(res.data)
    );
  } else {
    yield put(
      rootActions.deThi.cauTrucDeThi.LOAD_ERROR_CHON_CAU_HOI(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* saveWorker(action: ICauTrucDeThiActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as ISMT_CauTrucDe_Insert_Request;

  if (payload.cauTrucDe.id > 0) {
    res = yield call(cauTrucDeThiApi.Update, payload);
  } else {
    res = yield call(cauTrucDeThiApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.deThi.cauTrucDeThi.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.deThi.cauTrucDeThi.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: ICauTrucDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    cauTrucDeThiApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.deThi.cauTrucDeThi.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.deThi.cauTrucDeThi.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* loadSectionWorker(action: ICauTrucDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    cauTrucDeThiApi.SelectSection,
    action.payload
  );
  if (res.is_success) {
    yield put(rootActions.deThi.cauTrucDeThi.LOAD_SECTION_DATA_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.deThi.cauTrucDeThi.LOAD_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* deleteMultipleWorker(action: ICauTrucDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    cauTrucDeThiApi.DeleteMultiple,
    action.payload as number[]
  );
  if (res.is_success) {
    yield put(rootActions.deThi.cauTrucDeThi.DELETE_SUCCESS(res.data));
  } else {
    yield put(rootActions.deThi.cauTrucDeThi.DELETE_ERROR(res.message ?? "Có lỗi"));
  }
}
